<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__sync-error"
  >
    <template #pic>
      <div class="label-pic is-red">
        <icon
          data="@icon/alertSprint2.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Sprint Start Validation Error
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        v-if="sprintContent?.sprint?.sequenceNumber"
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        <a
          :href="sprintContent.acceptanceUrl"
          class="link .is-medium-500"
          >Sprint #{{ sprintContent.sprint.sequenceNumber }}</a
        >
        was started in Jira, but cannot be started in Project Simple due to validation errors.
      </BaseSubHeading>
      <BaseSubHeading
        v-else
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description"
      >
        Sprint was started in Jira, but cannot be started in Project Simple due to validation
        errors.
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { Notification } from "@/models/Notification"

@Options({
  name: "SPRINT_SYNC_ERROR",
  components: {
    NotificationTemplate
  }
})
export default class SPRINT_SYNC_ERROR extends Vue {
  @Prop() readonly notification: Notification
  get sprintContent() {
    return this.notification.content
  }
}
</script>
